// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3bfF5","container":"styles_container__3OjqP","title":"styles_title__J1nQ9","wrapper":"styles_wrapper__3YID8","answer":"styles_answer__2FUcP"};